import React, {useEffect, useState} from 'react';
import './App.scss';
import COLORS_ARRAY from "./colorsArray.js";
import { faTwitter, faTumblr, faWhatsapp, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


let quoteDBurl = "https://gist.githubusercontent.com/camperbot/5a022b72e96c4c9585c32bf6a75f62d9/raw/e3c6895ce42069f0ee7e991229064f167fe8ccdc/quotes.json"



function App() {
  const [quote, setQuote] = useState("Life is not about getting and having, it is about giving and being");

  const [author, setAuthor] = useState("Kevin Kruse");
 
  const [accentColor, setAccentColor] = useState('#7fb411')

  const [randomNumber, setRandomNumber] = useState(0);

  const [quotesArray, setQuotesArray] = useState(null);
   
      
    const fetchQuotes = async (url) => {
    const response = await fetch(url)
    const parsedJSON = await response.json()
    setQuotesArray(parsedJSON.quotes)
    console.log(parsedJSON)
    }

   useEffect(() => {
   
    fetchQuotes(quoteDBurl)

    },)

  const getRandomQuote = () => {
    let randomInteger = Math.floor(quotesArray.length * Math.random())
    setRandomNumber(randomInteger)
    setAccentColor(COLORS_ARRAY[randomInteger])
    setQuote(quotesArray[randomInteger].quote)
    setAuthor(quotesArray[randomInteger].author)
    }

  
   
  
return (
    <div className="App">
        <header className="App-header" style={{backgroundColor:accentColor}}>
        <div id='quote-box' style={{color:accentColor}}>
        <h6>Quote # : {randomNumber}</h6> 
        
        <p id='text'>
        <b>&#8220;</b>	
        {quote}
        <b>&#8221;</b>	
        </p>
        
        <p id='author'>
        - {author}</p>
        <div className='button'style={{backgroundColor:accentColor}}>
        <a id='tweet-quote' style={{backgroundColor:accentColor}} href={encodeURI(`http://www.twitter.com/intent/tweet?text=${quote} -${author}`)}>
        <FontAwesomeIcon icon={faTwitter}/></a>
        <a id='tumblr'style={{backgroundColor:accentColor}}lor href={encodeURI(`https://www.tumblr.com/explore/trending?source=homepage_explore=${quote} -${author}`)}>
        <FontAwesomeIcon icon={faTumblr}/></a>
        <a id='whatsapp'style={{backgroundColor:accentColor}} href={encodeURI(`https://wa.me/2348100000000=${quote} -${author}`)}>
        <FontAwesomeIcon icon= {faWhatsapp}/></a>
        <a id='facebook'style={{backgroundColor:accentColor}} href={encodeURI(`https://www.facebook.com/${quote} -${author}`)}>
        <FontAwesomeIcon icon= {faFacebook}/></a>
        </div> 

        <button id="new-quote" style={{backgroundColor:accentColor}} onClick={() => getRandomQuote() }><h2>New Quote</h2></button>
        
        </div>
      </header>
    </div>
  );
}



export default App;

